import { MessageContent } from 'flow/components/tickets/UseAttachmentHandler';

interface DefaultSignatureConditions {
    emailSignaturesEnabled: boolean;
    tabSelected: 'internal' | 'reply_external';
    originSubtype?: string;
    /** The default signature's HTML, if the user has one set. */
    defaultSignature?: string;
    messageContent: Pick<
        MessageContent,
        'emailSignature' | 'emailSignatureDismissed'
    >;
}

/**
 * Whether the default signature should be dropped into an external email reply.
 *
 * Two conditions are load-bearing beyond the obvious ones.
 *
 * Without a record that the author removed the signature on purpose, clearing
 * the field just invites the effect that applies the default to put it straight
 * back, and the remove button appears to do nothing at all.
 *
 * And an empty default has to be treated as no default. Applying one leaves the
 * field as empty as it started, so the condition that asked for it is still
 * true on the next run and the effect applies it forever.
 */
export const shouldApplyDefaultSignature = ({
    emailSignaturesEnabled,
    tabSelected,
    originSubtype,
    defaultSignature,
    messageContent,
}: DefaultSignatureConditions): boolean =>
    emailSignaturesEnabled &&
    tabSelected === 'reply_external' &&
    originSubtype === 'email' &&
    !!defaultSignature &&
    !messageContent.emailSignature &&
    !messageContent.emailSignatureDismissed;
